import * as angular from "angular";
import { CanvassStatusDataProvider } from "../../../data-provider/canvass-status.dp";
import { DialogUtils } from "../../../helper/dialog.helper";
import { CanvassStatus } from "../../../models/canvass-status.model";

let CanvassStatusComponent = {
    selector: "vcCanvassStatus",
    templateUrl:
        "/angular/components/canvass/modals/canvass-status.component.html",
    bindings: {
        selectedStatusId: "=",
    },
    controller: class CanvassStatusController {
        // * bindings for typescript compiler *
        public selectedStatusId: any;
        // ************************************

        public statuses: CanvassStatus[];
        public id: string | number;
        private dialog: DialogUtils;

        constructor(
            DialogUtils: DialogUtils,
            CanvassStatusDataProvider: CanvassStatusDataProvider
        ) {
            this.dialog = DialogUtils;

            CanvassStatusDataProvider.walkCanvassStatuses().then(
                (statuses: CanvassStatus[]) => {
                    this.statuses = statuses;
                }
            );
        }

        $onInit() {
            this.id = this.selectedStatusId;
        }

        confirm(): void {
            this.dialog.hide(this.id);
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("canvass")
    .component(CanvassStatusComponent.selector, CanvassStatusComponent);
